import React, { useState } from "react";
import { useQuestionStore } from "../stores/QuestionStore";
import classNames from "classnames";
import "./Hero.scss";

export const Hero = () => {
  const questionStore = useQuestionStore();
  const [isActive, setIsActive] = useState("Beliebteste");

  const onClickFavorite = (target) => {
    questionStore.setFavoriteQuestions();
    setIsActive(target.childNodes[0].nodeValue);
  };

  const onClickNewest = (target) => {
    questionStore.setNewestQuestions();
    setIsActive(target.childNodes[0].nodeValue);
  };

  const onClickRandom = (target) => {
    questionStore.setShuffledQuestions();
    setIsActive(target.childNodes[0].nodeValue);
  };

  return (
    <section className="hero">
      <div className="hero-body">
        <div className="container">
          <h1 className="title">DEEP QUEST COMMUNITY</h1>
          <h2 className="subtitle">Das Mittel gegen langweilige Gespräche!</h2>
        </div>
      </div>
      <div className="hero-foot">
        <nav className="tabs is-boxed is-fullwidth">
          <div className="container">
            <ul>
              <li className={classNames({ "is-active": isActive === "Beliebteste" })}>
                <a onClick={({ target }) => onClickFavorite(target)}>Beliebteste</a>
              </li>
              <li className={classNames({ "is-active": isActive === "Neuste" })}>
                <a onClick={({ target }) => onClickNewest(target)}>Neuste</a>
              </li>
              <li className={classNames({ "is-active": isActive === "Zufall" })}>
                <a onClick={({ target }) => onClickRandom(target)}>Zufall</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>
  );
};
